export default __webpack_public_path__ + "static/media/shared-links.8db8486e.svg";